<form
  [formGroup]="form"
  [nwxExposeFormErrors]="form"
  formName="current-carrier-comparison-form"
  >
  <div class="bolt-space-bottom-lg">
    <nwx-notification-bubble type="info">
      Third Party Vendor indicates a discrepancy in the prior policy
      information provided.
    </nwx-notification-bubble>
  </div>
  <div class="bolt-container table-container bolt-space-bottom-lg">
    <div class="bolt-row">
      <div class="bolt-col header-col"></div>
      <div class="bolt-col header-col">
        <span class="light-blue-circle"
          ><bolt-icon name="keyboard" fixed></bolt-icon></span
          >&nbsp;&nbsp;Previously entered
        </div>
        <div class="bolt-col header-col">
          <span class="light-blue-circle">
            <bolt-icon name="document" fixed></bolt-icon></span
            >&nbsp;&nbsp;Third Party Vendor
          </div>
        </div>
        <div class="bolt-row table-row grey-row">
          <div class="bolt-col label-col bolt-body-copy-sm">Lapse in coverage</div>
          <div class="bolt-col bolt-body-copy-sm text-center">
            {{
            getLapseVerbiage(currentCarrierComparison?.coverageLapseByAgent || '')
            }}
          </div>
          <div class="bolt-col bolt-body-copy-sm text-center">
            {{
            getLapseVerbiage(
            currentCarrierComparison?.coverageLapseInReport || ''
            )
            }}
          </div>
        </div>
        <div class="bolt-row table-row">
          <div class="bolt-col label-col bolt-body-copy-sm">Liability limits</div>
          <div class="bolt-col bolt-body-copy-sm text-center">
            {{
            getBILimitVerbiage(
            currentCarrierComparison?.currentBodilyInjuryLimitByAgent || ''
            )
            }}
          </div>
          <div class="bolt-col bolt-body-copy-sm text-center">
            {{
            getBILimitVerbiage(
            currentCarrierComparison?.currentBodilyInjuryLimitInReport || ''
            )
            }}
          </div>
        </div>
        <div class="bolt-row table-row grey-row">
          <div class="bolt-col label-col bolt-body-copy-sm">
            6mo terms with current carrier
          </div>
          <div class="bolt-col bolt-body-copy-sm text-center">
            {{ currentCarrierComparison?.currentCarrierTermsByAgent }}
          </div>
          <div class="bolt-col bolt-body-copy-sm text-center">
            {{ currentCarrierComparison?.currentCarrierTermsInReport }}
          </div>
        </div>
        <div class="bolt-row table-row">
          <div class="bolt-col label-col bolt-body-copy-sm">
            Count of auto carriers in the past 5 years
          </div>
          <div class="bolt-col bolt-body-copy-sm text-center">
            {{ currentCarrierComparison?.numberOfPriorCarriersByAgent }}
          </div>
          <div class="bolt-col bolt-body-copy-sm text-center">
            {{ currentCarrierComparison?.numberOfPriorCarriersInReport }}
          </div>
        </div>
      </div>
      <div class="bolt-container-fluid bolt-space-bottom-lg">
        <div class="bolt-row">
          <div
            class="bolt-col ack"
            [ngClass]="{ invalid: showAcknowledgementHighlight }"
            >
            @if (showAcknowledgementHighlight) {
              <bolt-icon
                name="exclamation-circle-filled"
                color="theme-error"
              ></bolt-icon>
            }
            <bolt-checkbox
              formControlName="acknowledgement"
              name="acknowledgement"
              value="true"
              arialabelledby="eligibility-ack-text"
              >
              <div class="bolt-body-copy-sm">
                I reviewed and confirm the submission will be updated based on the
                report data.
                <br />
                <br />
                The submission will be updated based on the report data. This may
                impact the quoted rate and eligiblity. This information may be
                reviewed on the Current auto carrier & limits section of the Auto
                quote page.
              </div>
            </bolt-checkbox>
          </div>
        </div>
      </div>
    </form>
